import { requireAuth } from '@/features/auth/guards/require-auth'
import { MaterialIssueEditorPage } from '@/features/material-issues/pages/material-issue-editor-page'
import { materialIssueDetailQuery } from '@/features/material-issues/queries/material-issue-queries'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { warehousesListQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { workOrdersListQuery } from '@/features/work-orders/queries/work-orders-list-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

const paramsSchema = z.object({
  materialIssueId: z.coerce.number().int().positive(),
})

export const Route = createFileRoute('/_app/material-issues/$materialIssueId')({
  beforeLoad: requireAuth,
  parseParams: paramsSchema.parse,
  stringifyParams: ({ materialIssueId }) => ({ materialIssueId: String(materialIssueId) }),
  loader: async ({ params, context }) => {
    const qc = context.queryClient
    const [note] = await Promise.all([
      qc.ensureQueryData(materialIssueDetailQuery(params.materialIssueId)),
      qc.ensureQueryData(projectsListQuery()),
      qc.ensureQueryData(usersListQuery()),
      qc.ensureQueryData(warehousesListQuery()),
      qc.ensureQueryData(workOrdersListQuery({ limit: 500, offset: 0 })),
    ])
    return { number: note.number }
  },
  // Crumb: «<список> › <номер документа>» — the number from the loader, not the id.
  staticData: {
    crumbParent: { label: messages.crumbs.materialIssues, to: '/material-issues/' },
    crumb: (m: { loaderData?: { number: string } }) => m.loaderData?.number ?? '…',
  },
  component: () => {
    const { materialIssueId } = Route.useParams()
    return <MaterialIssueEditorPage materialIssueId={materialIssueId} />
  },
})
